import { Text } from "@shopify/polaris"

import { showConfirmModal } from "./showConfirmModal"

export const showCWPlanModal = () => {
  showConfirmModal({
    title: t("PlanReminder"),
    onConfirm: async () => {
      pnav(`/integration?action=channelwill&tabsSelected=1`)
    },
    message: (
      <div>
        <Text variant="bodyMd" as="span" fontWeight="medium">
          {t("YouAreCurrentlyUsingCWILLsPac")}
        </Text>
      </div>
    ),
    extraPrimaryAction: {
      content: t("GoToView"),
    },
    extraCancelAction: {
      content: t("Close"),
    },
  })
}
